import { render } from "./MyClientFooter.vue?vue&type=template&id=8871dfce"
import script from "./MyClientFooter.vue?vue&type=script&lang=js"
export * from "./MyClientFooter.vue?vue&type=script&lang=js"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__